import type { GridApi } from "ag-grid-community";

// LQC-2482: AG Grid 31 only shows the no-rows overlay automatically when rowData
// is an empty array. When a filter hides every row, the grid renders nothing at all.
// AG Grid 35 adds a built-in "No matching rows" overlay for that case, so on upgrade
// to >= 35 the syncNoRowsOverlay wire-ups can go, but AGGridNoRowsOverlay's clear
// filters button is not built-in - re-evaluate rather than delete. See the "//" note
// above dependencies in package.json.

// Shown while a grid's fetch is still in flight - rowData undefined, not []. An empty
// array means "the fetch came back with nothing", which is the no-rows case below.
export const AG_GRID_LOADING_TEMPLATE =
  '<span class="agLoadingOverlayMessage">Loading...</span>';

export const NO_ROWS_MESSAGE = "No rows to show";
export const NO_MATCHING_ROWS_MESSAGE = "No rows match the current filters";

// True when the grid has row data but the active filters hide every row.
export function isFilteredToEmpty(api: GridApi): boolean {
  if (api.getDisplayedRowCount() > 0 || !api.isAnyFilterPresent()) return false;
  let hasRows = false;
  api.forEachNode(() => {
    hasRows = true; // forEachNode ignores filtering, unlike getDisplayedRowCount
  });
  return hasRows;
}

export function syncNoRowsOverlay(api: GridApi, isLoading: boolean): void {
  if (isLoading) return; // keep the loading overlay untouched
  if (api.getDisplayedRowCount() === 0) {
    // Each show builds a fresh AGGridNoRowsOverlay, so its message stays current.
    api.showNoRowsOverlay();
  } else {
    api.hideOverlay();
  }
}
